<template>
  <div :class="classes" class="trade-top-heading-block">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'TradeTopHeadingBlock',
  props: {
    smoothToggle: { type: Boolean, default: undefined },
    autoHeight: { type: Boolean, default: false },
    overflowAuto: { type: Boolean, default: false },
  },
  computed: {
    classes () {
      return {
        'trade-top-heading-block--auto-height-mobile': this.autoHeight,
        'trade-top-heading-block--hidden': !!this.smoothToggle,

        // for elements which specified smoothToggle, we use overflow: hidden
        // for elements which not specified smoothToggle, use initial overflow in order
        // to show tab's underline
        'trade-top-heading-block--hidable': this.smoothToggle !== undefined,
        'trade-top-heading-block--auto': this.overflowAuto,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.trade-top-heading-block {
  $laptop-screen: 1366px;
  // height: toRem(size(m));
  transition: all 0.1s;
  // padding-left: toRem(24px);

  &--hidden {
    height: 0px !important;
  }

  &--hidable {
    overflow: hidden;
  }

  &--auto {
    overflow: auto;
  }

  @include bp($laptop-screen) {
    // height: toRem(45px);
    max-height: toRem(50px);
    height: 100%;
  }

  &--auto-height-mobile {
    height: auto;

    @include bp(375px) {
      height: toRem(49.5px);
    }

    // @include bp($laptop-screen) {
    //   // height: toRem(45px);
    //   max-height: toRem(50px);
    //   height: 100%;
    // }
  }
}
</style>
